export function mergeAbortSignals(...rawSignals: (AbortSignal | null | undefined)[]) {
  const signals = rawSignals.filter((s): s is AbortSignal => !!s)

  for (const signal of signals) {
    if (signal.aborted) return signal
  }

  if (signals.length === 1) {
    return signals[0]
  }

  const controller = new AbortController()
  const controllerStack = new DisposableStack()

  function handleAbort() {
    controller.abort()
  }

  for (const signal of signals) {
    signal.addEventListener('abort', handleAbort)
    controllerStack.defer(() => {
      signal.removeEventListener('abort', handleAbort)
    })
  }

  controller.signal.addEventListener('abort', () => {
    controllerStack.dispose()
  })

  return controller.signal
}
